export { FontSizes, BaseSizePercentage } from "./FontSizes"
